module.exports = __webpack_public_path__ + "static/media/logout-icon-black.ea9216b1.svg";